import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

export const productCategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductCategories: builder.query({
      query: (args = {}) => ({
        url: '/api/product_categories',
        params: buildListQueryParams(args),
      }),
      providesTags: ['ProductCategories'],
    }),
    getProductCategoryById: builder.query({
      query: (id) => `/api/product_categories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ProductCategories', id }],
    }),
    createProductCategory: builder.mutation({
      query: ({ name, status = true, lead_time, buffer, guest_count }) => ({
        url: '/api/product_categories',
        method: 'POST',
        body: {
          product_category: {
            name,
            status,
            ...(lead_time !== undefined && lead_time !== '' ? { lead_time: Number(lead_time) } : {}),
            ...(buffer !== undefined && buffer !== '' ? { buffer: Number(buffer) } : {}),
            ...(guest_count !== undefined && guest_count !== ''
              ? { guest_count: Number(guest_count) }
              : {}),
          },
        },
      }),
      invalidatesTags: ['ProductCategories'],
    }),
    updateProductCategory: builder.mutation({
      query: ({ id, name, status, lead_time, buffer, guest_count }) => ({
        url: `/api/product_categories/${id}`,
        method: 'PUT',
        body: {
          product_category: {
            ...(name !== undefined ? { name } : {}),
            ...(status !== undefined ? { status } : {}),
            ...(lead_time !== undefined ? { lead_time } : {}),
            ...(buffer !== undefined ? { buffer } : {}),
            ...(guest_count !== undefined ? { guest_count } : {}),
          },
        },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'ProductCategories',
        { type: 'ProductCategories', id },
      ],
    }),
    updateProductCategoryStatus: builder.mutation({
      query: ({ id, name, status }) => ({
        url: `/api/product_categories/${id}`,
        method: 'PUT',
        body: {
          product_category: { name, status },
        },
      }),
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getProductCategories',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((c) => Number(c.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useGetProductCategoriesQuery,
  useGetProductCategoryByIdQuery,
  useCreateProductCategoryMutation,
  useUpdateProductCategoryMutation,
  useUpdateProductCategoryStatusMutation,
} = productCategoryApi;
